import { WidgetType } from "@codemirror/view";

export class IndicatorWidget extends WidgetType {
    constructor(content) {
        super();
        this.content = content;
    }

    toDOM() {
        const element = document.createElement("span");
        element.classList.add("ol-cm-indicator");
        element.textContent = this.content;
        return element;
    }

    eq(widget) {
        return widget.content === this.content;
    }

    updateDOM(element) {
        element.textContent = this.content;
        return true;
    }

    ignoreEvent(event) {
        return event.type !== "mousedown" && event.type !== "mouseup";
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
